import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import Icon from './Icon'
import { connect } from 'react-redux'
import { setItemHidden } from '../redux/actions'
import globals from '../globals'
import CustomLink from './CustomLink'

class ServiceRow extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            redirect: false
        }
    }

    handleClick () {
        if (this.props.url) {
            this.setState({
                redirect: true
            }, () => window.scrollTo(0, 0))
        }
    }

    handleClose (event) {
	    event.preventDefault()
        this.props.setItemHidden(this.props.customerId, this.props.closableKey)
        globals.pushEvent('CloseDisplayItem', { item: this.props.closableKey })
    }

    isExternal () {
        return /^https?:\/\//.test(this.props.url)
    }

    render () {
        if (this.state.redirect) {
            if (this.isExternal()) {
                window.open(this.props.url, '_blank')
            } else {
                return <Redirect push to={this.props.url} />
            }
        }

        const doHidePanel = this.props.closableKey && this.props.hiddenKeys && this.props.hiddenKeys.includes(this.props.closableKey)
        if (doHidePanel) {
		    return ''
        }

        return (
            <div
                className={`
                    row service-row
                    ${this.props.noUrl ? '' : 'arrow-right'}
                    ${this.props.isAddService ? 'no-text' : ''}
                    ${this.props.isSubService ? 'sub-service-row' : ''}
                `}
                onClick={this.handleClick.bind(this)}
            >
                {this.props.isSubService
                    ? <div className='col-md-1 d-none d-md-flex align-items-center'>
                        <div style={{ width: '45px' }} className='text-center'>
                            <img src='/images/icon-sub-service-arrow1.png' alt='' width='20px' />
                        </div>
                      </div>
                    : ''}
                <div className={`${this.props.isSubService ? 'col-md-3' : 'col-md-4'} col-11 d-flex align-items-center`}>
                    <Icon src={this.props.icon} className='icon text-center' />
                    <div>
                        {(this.props.preTitle
                            ? <div><small>{this.props.preTitle}</small></div>
                            : '')}
                        <h3 className='my-0 lime' dangerouslySetInnerHTML={{ __html: this.props.title }} />
                        {(this.props.subTitle
                            ? <div><small>{this.props.subTitle}</small></div>
                            : '')}
                    </div>
                </div>
                {this.props.children
                    ? <div className={`col-md-7 ${this.props.noUrl ? 'col-12' : 'col-10'} mt-3 mt-md-0`}>
                        {this.props.children}
                      </div>
                    : ''}
                {!this.props.noUrl
                    ? <div className='col-md-1 manage d-flex justify-content-center align-items-center flex-column'>
                        <img src='/images/icon-arrow-right.svg' alt='Manage' className='mb-2' />
                        <small>Manage</small>
                      </div>
                    : ''}
                {this.props.closable
                    ? <a href='#' className='close do-animate-rollover-large' title='Hide on this device' onClick={this.handleClose.bind(this)}>
                        <img src='/images/icon-close.svg' alt='close' />
                      </a>
                    : ''}
            </div>
        )
    }
}

ServiceRow.propTypes = {
    isAddService: PropTypes.bool,
    isSubService: PropTypes.bool,
    noUrl: PropTypes.bool,
    closable: PropTypes.bool,
    closableKey: PropTypes.string, // Required with closable:true
    url: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    preTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

const mapStateToProps = state => ({
    customerId: state.auth.id,
    hiddenKeys: state.display[state.auth.id]
})

export default connect(mapStateToProps, { setItemHidden })(ServiceRow)



// WEBPACK FOOTER //
// ./resources/js/components/ServiceRow.js